import { FunctionComponent } from "react";

export interface ValueSelector<T extends unknown> {
    value: T;
    changeValue: (value: T) => void;
    disabled?: boolean;
    className?: string;
    testId?: string;
    dataCy?: string;
}

type AdditionalOnly<TProps extends ValueSelector<unknown>> = Omit<TProps, "value" | "changeValue" | "disabled" | "className">;
type GenericOnly<TProps extends ValueSelector<unknown>> = Pick<TProps, "value" | "changeValue" | "disabled" | "className" | "testId" | "dataCy">;

export type ValueSelectorComponentCreator<TProps extends ValueSelector<unknown>> = (
    // If There are no required additional props on the specific selector, then no params are required for the factory function
    ...props: GenericOnly<TProps> extends TProps ? [] | [AdditionalOnly<TProps>] : [AdditionalOnly<TProps>]
) => (props: GenericOnly<TProps>) => ReturnType<FunctionComponent<TProps>>;
